// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"myGift_wrapper_yKfXo","box":"myGift_box_1m7u_","gift-item":"myGift_gift-item_9ehrA","info":"myGift_info_1AtP5","btn":"myGift_btn_3fgQ6","nomore":"myGift_nomore_i94ja"};